import { useParams } from "react-router-dom";
import LandingPageData from '../static/landingPage';
import MainLayout from '../layout/Main';
import { useState, useEffect, useRef, useMemo } from 'react';
import Loading from "../components/common/Loading";

const IframePage = ({ urlTitle, url, menuData, activePage, activePageLayout, handlePageChange }) => {
    const { playlistTitle } = useParams();
    const prevUrlRef = useRef(url); // Track prev url to dedupe changes
    const [isLoading, setIsLoading] = useState(true);
    
    // Memoize decodedTitle: Stable across renders
    const decodedTitle = useMemo(() => decodeURIComponent(urlTitle || playlistTitle), [urlTitle, playlistTitle]);

    // Deduped effect: Only run if url *actually* changed (ignores StrictMode doubles)
    useEffect(() => {
        if (url !== prevUrlRef.current) {
            prevUrlRef.current = url;
            setIsLoading(true);
            // Fallback timeout: Hide loader after 3s if onLoad fails (tune as needed)
            const timer = setTimeout(() => setIsLoading(false), 3000);
            return () => clearTimeout(timer);
        }
    }, [url]);

    const handleIframeLoad = () => {
        // Add min display time: Ensure loader shows at least 500ms for consistency
        setTimeout(() => setIsLoading(false), 500);
    };




    return (
        <MainLayout
            menuData={menuData}
            activePage={activePage}
            handlePageChange={handlePageChange}
            activePageLayoutType={activePageLayout.layout}
            copyRightText={LandingPageData.copyRight}
        >
            <div className={`${playlistTitle === "Subscribe" ? "subscribe_top_menu" : ""} iframe-scroll-web`} suppressHydrationWarning>
                {isLoading && (
                    <Loading showVideo />
                )}
                <iframe
                    src={url}
                    title={decodedTitle}
                    width="100%"
                    height="100%"
                    style={{ 
                        border: "none",
                        position: 'relative',
                        zIndex: 0
                    }}
                    sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
                    onLoad={handleIframeLoad}
                    suppressHydrationWarning // Suppress if src mismatches on hydrate
                />
            </div>
        </MainLayout>
    );
};

export default IframePage;